module.exports = __webpack_public_path__ + "assets/img/icon5.3290db67.svg";